import { gql } from "@apollo/client";

export const CREATE_RI_EV = gql`
mutation createRIEV(    
    $data: RIEVMedicoSaveInput!){
    saveRIEVMedico(
        data: $data
    ) {
        success,
        error,
        valorEsperado
    }
}
`;